import type { FC, ReactNode } from 'react'
import type { JournalPostSummary } from '@/types'

import { cn } from '@/lib/utils'
import { SplitChars } from '@/components/motion/split-text'
import StoryCard from '@/components/journal/story-card'
import Button from '@/components/generals/button'

interface JournalTeaserProps {
    posts: Array<JournalPostSummary>
}

const JournalTeaser: FC<JournalTeaserProps> = ({ posts = [] }): ReactNode => {
    if (!posts.length) return null

    return (
        <section id='from-the-journal' aria-label='From the journal' className='relative border-t border-line bg-ink py-24 gutter md:py-36'>
            <div className='flex flex-wrap items-end justify-between gap-6'>
                <div>
                    <p data-reveal='fade' className='label-mono text-acid'>
                        (07) — Journal
                    </p>

                    <h2 data-reveal='chars' className='mt-5 display-l uppercase'>
                        <SplitChars text='From the journal' />
                    </h2>
                </div>

                <div data-reveal='fade'>
                    <Button href='/journal' variant='ghost'>
                        All stories
                    </Button>
                </div>
            </div>

            <div className='mt-14 grid gap-14 md:mt-20 md:grid-cols-3 md:gap-6 lg:gap-8'>
                {posts.map((post, index) => (
                    <StoryCard
                        key={post.id}
                        post={post}
                        className={cn(index === 1 && 'md:mt-24', index === 2 && 'md:mt-10')}
                    />
                ))}
            </div>
        </section>
    )
}

export default JournalTeaser
